import { render, staticRenderFns } from "./pageCosmetics.vue?vue&type=template&id=7239d97a&scoped=true&"
import script from "./pageCosmetics.vue?vue&type=script&lang=js&"
export * from "./pageCosmetics.vue?vue&type=script&lang=js&"
import style0 from "./pageCosmetics.vue?vue&type=style&index=0&id=7239d97a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7239d97a",
  null
  
)

export default component.exports